import api from './api';

/**
 * Discriminated response from the unified public resolver.
 *
 * The backend resolves a slug against MenuShare first, then WineListShare,
 * and tags the payload with `kind` so the frontend can branch without an
 * extra round trip.
 */
export type PublicResolveResponse =
  | { kind: 'menu'; data: any }
  | { kind: 'wine-list'; data: any };

/**
 * Anonymous, public unified resolver. Hits the unauthenticated
 * /api/public/m/:slug endpoint.
 *
 * The `api` axios client may attach a stale auth token from localStorage if
 * the device has ever been logged in to admin — that's harmless: the public
 * endpoint ignores authentication entirely.
 */
const publicResolveService = {
  /**
   * Resolve a public slug. When venueDomain is provided the venue-scoped form
   * /public/m/:venueDomain/:slug is used (MENU-PUBLIC-URL-SLUGS.1) — the
   * backend validates the domain against the share's venue and 404s on
   * mismatch. Without venueDomain the legacy single-segment form is used.
   */
  getBySlug: async (slug: string, venueDomain?: string): Promise<PublicResolveResponse> => {
    const path = venueDomain
      ? `/public/m/${encodeURIComponent(venueDomain)}/${encodeURIComponent(slug)}`
      : `/public/m/${encodeURIComponent(slug)}`;
    const response = await api.get(path);
    return response.data;
  },
};

export default publicResolveService;
